<template>
  <div class="expand-more">
    <div class="expand-more-box">
      <el-button type="text"
                 :icon="showDom ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"
                 class="more-btn"
                 @click="openMore()"> {{ showDom ? '收起':'更多功能'}} </el-button>
      <slot v-if="showDom"></slot>
    </div>

  </div>
</template>
<script>
export default {
  name: 'ExpandMore',
  props: {},
  data() {
    return {
      showDom: false,
    }
  },
  mounted() {},
  methods: {
    openMore() {
      this.showDom = !this.showDom
      this.getOffsetWidth(this.showDom)
    },

    getOffsetWidth(type) {
      this.$nextTick(() => {
        const menuDom = document.querySelector('.avue-crud__menu')
        if (menuDom) {
          const menuDomWidth = menuDom.offsetWidth
          const menuDomLeft = document.querySelector('.avue-crud__left')
          const menuDomRight = document.querySelector('.avue-crud__right')
          const expandMore = document.querySelector('.expand-more')
          const Width =
            menuDomWidth -
            (menuDomLeft.offsetWidth - expandMore.offsetWidth) -
            menuDomRight.offsetWidth
          expandMore.style.width = type ? Width - 60 + 'px' : '58px'
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.expand-more {
  position: relative;
  display: inline-block;
  vertical-align: top;
  max-width: 48%;
  min-width: 85px;
  overflow-y: scroll;
  white-space: nowrap;
  height: 48px;
  .expand-more-box {
    width: calc(100% - 52px);
    overflow-y: scroll;
    white-space: nowrap;
    height: 100%;
  }
  .el-button--text {
    padding: 10px 0px;
    margin-right: 0px !important;
  }
  .more-btn {
    position: absolute;
    right: 5px;
  }
  .el-button i {
    margin-right: -2px;
  }
}
</style>
